// components/EventList/EventList.jsx
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import './EventList.css';

const EventList = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const eventsQuery = query(collection(db, 'events'), orderBy('date', 'asc'));
      const querySnapshot = await getDocs(eventsQuery);
      
      const eventsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setEvents(eventsData);
      setError(null);
    } catch (error) {
      console.error('Error fetching events:', error);
      setError('Failed to load events. Please try again later.');
      // Set some default data to prevent app from crashing
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };

  // Default events data for when Firebase is not connected or has no data
  const defaultEvents = [
    {
      id: '1',
      title: 'Tech Conference 2025',
      type: 'Technology',
      date: '2025-02-15',
      location: 'Mumbai, India',
      price: 2500,
      status: 'in-progress',
      statusText: 'In Progress',
      image: 'https://via.placeholder.com/300x200/2563eb/ffffff?text=Tech+Conference',
      participantsCount: 0
    },
    {
      id: '2',
      title: 'Summer Music Festival',
      type: 'Entertainment',
      date: '2025-03-20',
      location: 'Goa, India',
      price: 5000,
      status: 'not-reported',
      statusText: 'Not Reported',
      image: 'https://via.placeholder.com/300x200/fbbf24/000000?text=Music+Festival',
      participantsCount: 0
    },
    {
      id: '3',
      title: 'Startup Meetup',
      type: 'Business',
      date: '2025-01-10',
      location: 'Bangalore, India',
      price: 0,
      status: 'successfully-done',
      statusText: 'Successfully Done',
      image: 'https://via.placeholder.com/300x200/10b981/ffffff?text=Startup+Meetup',
      participantsCount: 45
    }
  ];

  const handleRegister = (eventId, eventTitle) => {
    alert(`Registration for ${eventTitle} - Feature coming soon!`);
  };

  if (loading) {
    return (
      <section className="event-list" id="events">
        <div className="event-list-container">
          <h2 className="event-list-title">Loading Events...</h2>
        </div>
      </section>
    );
  }

  // Use default events if no events from Firebase or if there's an error
  const displayEvents = events.length > 0 ? events : defaultEvents;

  return (
    <section className="event-list" id="events">
      <div className="event-list-container">
        <h2 className="event-list-title">Upcoming Events</h2>
        
        {error && (
          <div className="error-message" style={{ textAlign: 'center', color: '#ef4444', marginBottom: '20px' }}>
            {error}
          </div>
        )}
        
        <div className="events-grid">
          {displayEvents && displayEvents.length > 0 ? (
            displayEvents.map((event) => (
              <div key={event.id} className="event-card">
                <img 
                  src={event.image || 'https://via.placeholder.com/300x200/2563eb/ffffff?text=Event'} 
                  alt={event.title} 
                  className="event-image"
                />
                <div className="event-details">
                  <h3 className="event-title">{event.title}</h3>
                  <p className="event-type">{event.type}</p>
                  <p className="event-date">📅 {event.date}</p>
                  <p className="event-location">📍 {event.location}</p>
                  <div className="event-footer">
                    <span className="event-price">
                      {event.price === 0 || event.price === 'Free' ? 'Free' : `₹${event.price}`}
                    </span>
                    <span className={`event-status ${event.status}`}>
                      {event.statusText}
                    </span>
                  </div>
                  {event.participantsCount !== undefined && (
                    <p className="participants-count">
                      {event.participantsCount} participants registered
                    </p>
                  )}
                  <button 
                    className="event-action"
                    onClick={() => handleRegister(event.id, event.title)}
                    disabled={event.status === 'cancelled' || event.status === 'successfully-done'}
                  >
                    {event.status === 'successfully-done' ? 'Event Completed' : 
                     event.status === 'cancelled' ? 'Event Cancelled' : 
                     'Register Now'}
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="no-events">No events available at the moment.</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default EventList;